import api from "@/services/api";

const clean = (o) =>
  Object.fromEntries(Object.entries(o).filter(([, v]) => v !== undefined && v !== null && v !== ""));

export const bookingService = {
  list: (params = {}) => api.get("/bookings", { params: clean(params) }).then((r) => r.data.data),
  get: (id) => api.get(`/bookings/${id}`).then((r) => r.data.data),
  create: (payload) => api.post("/bookings", clean(payload)).then((r) => r.data.data),
  update: (id, payload) => api.patch(`/bookings/${id}`, clean(payload)).then((r) => r.data.data),
  cancel: (id, reason) => api.post(`/bookings/${id}/cancel`, { reason }).then((r) => r.data.data),
  listArchived: () => api.get("/bookings/archived").then((r) => r.data.data),
  archive: (id) => api.post(`/bookings/${id}/archive`).then((r) => r.data.data),
  restore: (id) => api.post(`/bookings/${id}/restore`).then((r) => r.data.data),
  deletePermanently: (id) => api.delete(`/bookings/${id}/permanent`).then((r) => r.data.data),
  // Status change with comment is handled by PATCH (backend records status_history).
  updateStatus: (id, status, comment) =>
    api.patch(`/bookings/${id}`, clean({ status, status_comment: comment })).then((r) => r.data.data),
};

export const STATUS_STYLE = {
  Draft: "rounded-full border-transparent bg-muted text-muted-foreground ring-1 ring-inset ring-border/70",
  Pending: "rounded-full border-transparent bg-amber-500/10 text-amber-700 ring-1 ring-inset ring-amber-500/20 dark:text-amber-300",
  Confirmed: "rounded-full border-transparent bg-sky-500/10 text-sky-700 ring-1 ring-inset ring-sky-500/20 dark:text-sky-300",
  "In Progress": "rounded-full border-transparent bg-violet-500/10 text-violet-700 ring-1 ring-inset ring-violet-500/20 dark:text-violet-300",
  "Waiting for Parts": "rounded-full border-transparent bg-orange-500/10 text-orange-700 ring-1 ring-inset ring-orange-500/20 dark:text-orange-300",
  Completed: "rounded-full border-transparent bg-emerald-500/10 text-emerald-700 ring-1 ring-inset ring-emerald-500/20 dark:text-emerald-300",
  Cancelled: "rounded-full border-transparent bg-red-500/10 text-red-700 ring-1 ring-inset ring-red-500/20 dark:text-red-300",
};

export const PRIORITY_STYLE = {
  Low: "text-muted-foreground",
  Normal: "text-foreground",
  High: "text-orange-500",
  Urgent: "text-red-500",
};
